import React, { useState, useEffect, useContext } from "react";
import { Layout, Menu, Icon, Row, Col } from "antd";
import Colors from "../../theme/colors";
import { Logo } from "./styles";
import { routes } from "../../router/routes";
import { AuthContext } from "../../App";
import { useTranslation  } from 'react-i18next'

const { Sider } = Layout;
const SiderMenu = ({ Link }) => {
  const { dispatch } = useContext(AuthContext);
  const [selectedKey, setSelectedKey] = useState("1");
  const { t } = useTranslation();

  useEffect(() => {
    if (window.location.pathname) {
    //  let new_route = routes.find(route => ("/bikiforge"+route.path.slice(1, route.path.length)) === window.location.pathname);
    //  if (new_route && new_route.key) setSelectedKey(new_route.key);
  let new_route = routes.find(route => route.pathlargo === window.location.pathname);
      if (new_route && new_route.key){
console.log("setselectedkey ", new_route.key); 
setSelectedKey(new_route.key);
 
  }
  
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const logout = e => {
    e.preventDefault();
    dispatch({ type: "LOGOUT" });
  };

  return (
    <Sider width={140}>
      <Logo >
        BikiFORGE
      </Logo>
      <Menu
        theme="dark"
        selectedKeys={[selectedKey]}
        mode="inline"
      >
        {routes.map(
          route =>
            route.key && (
              <div
                style={{
                  width: "100%",
                  paddingBottom: "10px",
                  backgroundColor: selectedKey === route.key && Colors.primary
                }}
                key={route.key}
              >
                <Link to={route.path}>
                  <Row type="flex" justify="center" align="middle" style={{ height: "75px" }}>
                    <Col
                      span={24}
                      style={{ textAlign: "center", color: selectedKey === route.key ? "white" : "rgba(255, 255, 255, 0.65)" }}
                    >
                      <Icon type={route.icon} style={{ fontSize: "19px" }} />
                    </Col>
                    <Col
                      span={24}
                      style={{ textAlign: "center", color: selectedKey === route.key ? "white" : "rgba(255, 255, 255, 0.65)" }}
                    >
                      <span>{t('menu.'+route.text)}</span>
                    </Col>
                  </Row>
                </Link>
              </div>
            )
        )}

        <div
          style={{
            width: "100%",
            paddingBottom: "10px",
            bottom: 0,
            position: "absolute",
            cursor: "pointer"
          }}
          onClick={e => logout(e)}
        >
          <Row type="flex" justify="center" align="middle" style={{ height: "80px" }}>
            <Col span={24} style={{ textAlign: "center", color: "rgba(255, 255, 255, 0.65)" }}>
              <Icon type="logout" style={{ fontSize: "19px" }} />
            </Col>
            <Col span={24} style={{ textAlign: "center", color: "rgba(255, 255, 255, 0.65)" }}>
              <span>{t('menu.logout')}</span>
            </Col>
          </Row>
        </div>
      </Menu>
    </Sider>
  );
};

export default SiderMenu;
